import React from 'react';
import QRCode from 'react-qr-code';

import PayconiqMark from '../../../../../../../assets/logos/payconiq_mark.svg';
import { markwrapper, qrbackground, qrcode, qrwrapper } from '../PayconiqRedirect.scss';

interface Props {
  qrCodeData?: string;
  payconiqColor: string;
}

const QrComponent = ({ qrCodeData, payconiqColor }: Props) => {
  if (qrCodeData) {
    return (
      <div className={qrwrapper}>
        <div className={qrbackground}>
          <QRCode
            size={180}
            className={qrcode}
            fgColor={payconiqColor}
            value={qrCodeData}
            viewBox={`0 0 180 180`}
          />
          <div className={markwrapper}>
            <PayconiqMark />
          </div>
        </div>
      </div>
    );
  }
  return null;
};

export default QrComponent;
